import { render } from "./hero.vue?vue&type=template&id=2529d12b&scoped=true"
const script = {}

import "./hero.vue?vue&type=style&index=0&id=2529d12b&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\zoinix-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2529d12b"]])

export default __exports__